import MobileSliderPagesWrapper from "../components/MobileSliderPagesWrapper";
import MobileSliderPagesHeader from "../components/MobileSliderPagesHeader";
import { useLocation } from "react-router";
import { useMemo } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import {
    getLiteTradeAccountOrders,
    getLiteTradeAccountPositions
} from "../../../../modules/LiteTrade/liteTradeSelectors";
import _ from "lodash";
import MobileOrderHeader from "../../MobilePosition/MobilePositionHeader/MobilePositionHeader";
import MobilePositionUpdate from "../../MobilePosition/MobilePositionUpdate/MobilePositionUpdate";
import { MobileSliderPagesContentStyled } from "../components/styled/MobileSliderPagesStyled";
import { getUserSelectedAccountCode } from "../../../../app/appSelectors";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext";

function SlideMobilePositionUpdate(props) {
    const {getLangPath} = useLangContext();
    const {orders, positions, selectedAccountCode} = props;
    const location = useLocation();

    const {orderId, positionCode} = useMemo(() => {
        const searchParams = new URLSearchParams(location.search);
        return {orderId: searchParams.get('order-id'), positionCode: searchParams.get('position-code')}
    }, [location.search]);

    const order = useMemo(() => _.find(orders, {orderId: parseInt(orderId)}), [orderId, orders]);
    const position = useMemo(() => _.find(positions, {positionCode}), [positionCode, positions]);
    const symbol = order?.instrument || position?.symbol;

    return <MobileSliderPagesWrapper backgroundColor="var(--color-base)">
        <MobileSliderPagesHeader goBack>
            <MobileOrderHeader symbol={symbol}>
                {getLangPath(`lite_version.edit_position.${order ? 'edit_order' : 'button'}`)}
            </MobileOrderHeader>
        </MobileSliderPagesHeader>
        <MobileSliderPagesContentStyled>
            <MobilePositionUpdate
                accountCode={selectedAccountCode}
                orderId={orderId}
                positionCode={positionCode}
                symbol={symbol}
            />
        </MobileSliderPagesContentStyled>
    </MobileSliderPagesWrapper>
}

const mapStateToProps = createStructuredSelector({
    selectedAccountCode: getUserSelectedAccountCode,
    orders: getLiteTradeAccountOrders,
    positions: getLiteTradeAccountPositions,
});

export default connect(mapStateToProps)(SlideMobilePositionUpdate);
